import { render, staticRenderFns } from "./VideoMore.vue?vue&type=template&id=416b8e85&scoped=true"
import script from "./VideoMore.vue?vue&type=script&lang=js"
export * from "./VideoMore.vue?vue&type=script&lang=js"
import style0 from "./VideoMore.vue?vue&type=style&index=0&id=416b8e85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416b8e85",
  null
  
)

export default component.exports